import {http} from '../../plugins/http';

export default {

    /**
     * @param {string} taskKey
     * @param {Object} [params]
     *
     * @returns {Promise.<Object>}
     */
    index(taskKey, params = {}) {
        return http.get(`/api/v1/projects/tasks/${taskKey}/logs`, {params: params});
    },

    /**
     * @param {string} taskKey
     * @param {Object} params
     *
     * @returns {Promise.<Object>}
     */
    store(taskKey, params) {
        return http.post(`/api/v1/projects/tasks/${taskKey}/logs`, params);
    },

    /**
     * @param {string} workLogKey
     *
     * @returns {Promise.<Object>}
     */
    show(workLogKey) {
        return http.get(`/api/v1/projects/tasks/logs/${workLogKey}`, params);
    },

    /**
     * @param {string} workLogKey
     * @param {Object} params
     *
     * @returns {Promise.<Object>}
     */
    update(workLogKey, params) {
        return http.patch(`/api/v1/projects/tasks/logs/${workLogKey}`, params);
    },

    /**
     * @param {string} workLogKey
     *
     * @returns {Promise.<Object>}
     */
    destroy(workLogKey) {
        return http.delete(`/api/v1/projects/tasks/logs/${workLogKey}`);
    },

    move(workLogKey, targetTaskKey) {
        return http.post(`/api/v1/projects/tasks/logs/${workLogKey}/move`, {target_task: targetTaskKey});
    },

    moveMultiple(workLogs, targetTaskKey) {
        return http.post(`/api/v1/projects/tasks/logs/move_multiple`, {
            work_logs: workLogs, target_task: targetTaskKey
        });
    },

    /**
     * @param {int} weekOffset
     *
     * @returns {Promise.<Object>}
     */
    staffWorkDone(weekOffset) {
        return http.get(`/api/v1/work-logs/work-done/staff`, {
            params: {
                week: weekOffset
            }
        });
    },

    /**
     * @param {int} weekOffset
     * @param {string} userKey
     *
     * @returns {Promise.<Object>}
     */
    userWorkDone(weekOffset, userKey = '') {
        const userParam = userKey ? `/${userKey}` : '';

        return http.get(`/api/v1/work-logs/work-done/user${userParam}`, {
            params: {
                week: weekOffset
            }
        });
    },

    /**
     *
     * @returns {Promise.<Object>}
     */
    staffWorkLoad() {
        return http.get(`/api/v1/work-logs/work-load/staff`);
    },

    /**
     * @param {Object} params
     * @returns {*|AxiosPromise<any>}
     */
    changeRemainingWork(params) {
        return http.post(`/api/v1/projects/tasks/logs/changeRemaining`, params);
    },

    /**
    *
    * @param {Object} params
    * @returns {*|AxiosPromise<any>}
    */
    isRescheduleRequired(params) {
        return http.post(`/api/v1/projects/tasks/logs/calculateRemainingDifference`, params);
    },

    /**
     *
     * @param params
     * @returns {Promise<AxiosResponse<any>>}
     */
    calculateNewTimeEstimation(params) {
        return http.post(`/api/v1/projects/tasks/logs/calculateTimeEstimated`, params);
    },

    /**
     *
     * @param params
     * @returns {Promise<AxiosResponse<any>>}
     */
    saveTimeEstimation(params) {
        return http.post(`/api/v1/projects/tasks/logs/saveTimeEstimated`, params);
    },

    /**
     *
     * @param params
     * @returns {Promise<AxiosResponse<any>>}
     */
    getMovableWorklogsFromProject(params) {
        return http.post(`/api/v1/projects/tasks/logs/getMovableWorklogs`, params);
    }

};



// WEBPACK FOOTER //
// ./src/services/Tasks/TaskWorkLogController.js